import { render, staticRenderFns } from "./puPlanList.vue?vue&type=template&id=bef86daa&scoped=true"
import script from "./puPlanList.vue?vue&type=script&lang=js"
export * from "./puPlanList.vue?vue&type=script&lang=js"
import style0 from "./puPlanList.vue?vue&type=style&index=0&id=bef86daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef86daa",
  null
  
)

export default component.exports